import { resourceHelper } from '../ResourceHelper';

export class PixiBase {
  constructor() {
    const { PIXI } = window;
    this.PIXI = PIXI;
  }

  loadResource(resource, loader) {
    const source = resourceHelper.filter(resource);
    const declared = resourceHelper.getDeclaredResources(resource);
    return new Promise((resolve) => {
      source
        .reduce((
          load,
          { name, path, config },
        ) => load.add(name, path, config), loader)
        .load((loader, res) => {
          resourceHelper.declareResources(res);
          resolve({
            res: {
              ...declared,
              ...res,
            },
          });
        });
      this.PIXI.utils.clearTextureCache();
    });
  }
}
